export default "__VITE_ASSET__DdCWKV3y__"